import { addDataLayerEntry } from '@printdeal/data-layer-manager';
import { Experiment } from '@printdeal/feature-management/react';
import { Alert, LinkAsButton } from '@printdeal/ui-library';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const PriceCheckAlert = () => {
  const openPriceCheckModal = () => {
    addDataLayerEntry('price_check_click');
    // open mOpinion price check modal
    // @ts-expect-error
    srv.openModal(true, 'd21fb27f8d7f86d648d236b75363fecd932bf5a4');
  };

  return (
    <Experiment id="ninjas-exp1685-price-check">
      <Experiment.Variant>
        <Alert variant="dim">
          <FormattedMessage
            id="general.pricecheck.title"
            defaultMessage="Is the price not as expected?"
          />
          <LinkAsButton onClick={openPriceCheckModal} className="pd-pl-1 pd-underline">
            <FormattedMessage
              id="general.pricecheck.link"
              defaultMessage="Get in touch"
            />
          </LinkAsButton>
        </Alert>
      </Experiment.Variant>
    </Experiment>
  );
};
